
import React, { useEffect, useState } from "react";
import Sidebar from "./MainSidebar";
import Breadcrumbs from "./Breadcrumbs";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import LoggingService from "../../services/LoggingService";
import TenantSelection from "./TenantSelection";
import { useTenant } from "../../context/TenantContext";  //  Use global tenant context
import "../../styles/Layout.css";
import config from '../../config/config';
import Modal from 'react-modal';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedTenant, setSelectedTenant } = useTenant();  //  Get global tenant state
  const [tenants, setTenants] = useState([]); // Store available tenants

  useEffect(() => {
    fetchTenants(); // Fetch available tenants when component mounts

  }, []);

  const fetchTenants = async () => {
    try {
      const token = localStorage.getItem("userToken");
      if (!token) {
        console.error("❌ No user token found. User may not be logged in.");
        return;
      }

      const response = await axios.get(`${config.API_BASE_URL}/api/orchestrator/tenants`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.tenants && response.data.tenants.length > 0) {
        setTenants(response.data.tenants);

        //  Check if a tenant is already selected in localStorage
        const storedTenant = localStorage.getItem("selectedTenant");

        if (storedTenant) {
          const parsedTenant = JSON.parse(storedTenant);
          setSelectedTenant(parsedTenant);  //  Update global state
        } else {
          // If no tenant is stored, set the first one as default
          const defaultTenant = response.data.tenants[0];
          setSelectedTenant(defaultTenant);
          localStorage.setItem("selectedTenant", JSON.stringify(defaultTenant));
        }
      } else {
        console.error("❌ No tenants found in the response.");
      }
    } catch (error) {
      console.error("❌ Error fetching tenants:", error.response?.data || error.message);
    }
  };

  const handleTenantChange = (tenantId) => {
    const tenant = tenants.find((t) => String(t.id) === String(tenantId));

    if (tenant) {
      setSelectedTenant(tenant); //  Update global state
      localStorage.setItem("selectedTenant", JSON.stringify(tenant)); //  Persist selection
    } else {
      console.error("❌ Selected tenant not found in the tenants list.");
    }
  };

  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const handleLogout = async () => {
    setIsLogoutModalOpen(true); // Open modal instead of browser confirm
  };

  const confirmLogout = async () => {
    try {
      const token = localStorage.getItem("userToken");
      if (token) {
        await axios.post(
          `${config.API_BASE_URL}/api/auth/logout`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
    } catch (error) {
      console.error("Logout error:", error.message);
    } finally {
      localStorage.removeItem("userToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("selectedTenant");
      //localStorage.removeItem("premiseOrCloud");
      setSelectedTenant(null);
      LoggingService.log("User logged out. Navigating to login page.");
      navigate("/login");
      setIsLogoutModalOpen(false);
    }
  };

  return (
    <div className="layout-container">
      <header className="layout-header">
        <div className="logout-section">
          {/* ✅ Wrap Label & Dropdown in a container */}
          <div className="tenant-selection-container">

            <TenantSelection
              onTenantChange={handleTenantChange}
              selectedTenant={selectedTenant?.id || ""}
              isGlobal={true}
            />
          </div>

          <button className="logout-button" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div className="breadcrumbs-container">
          <Breadcrumbs />
        </div>
      </header>

      {<Sidebar />}
      <div className="page-content">
        {children}
      </div>

      <Modal
        isOpen={isLogoutModalOpen}
        onRequestClose={() => setIsLogoutModalOpen(false)}
        className="logout-modal"
        overlayClassName="logout-modal-overlay"
      >
        <div className="logout-modal-content">
          <h2>Confirm Logout</h2>
          <p>Are you sure you want to log out?</p>
          <div className="logout-modal-buttons">
            <button onClick={confirmLogout}>Yes, Logout</button>
            <button onClick={() => setIsLogoutModalOpen(false)}>Cancel</button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Layout;
